module.exports = __webpack_public_path__ + "img/kuaishou.4daaeb3f.png";